import clsx from "clsx";

import { type BudgetMixBreakdownSpendDatum } from "@north-beam/nb-common";

import BudgetMixChartContainer from "../budget-mix-chart";
import BudgetMixTable from "../budget-mix-table";

export function ChartTableSection({
  chartData,
  useChart,
  isHistorical = false,
}: {
  chartData: BudgetMixBreakdownSpendDatum[];
  useChart: boolean;
  isHistorical?: boolean;
}) {
  return (
    <div
      className={clsx("w-full border-b border-v2-secondary", {
        "py-3 flex flex-col justify-end items-end": useChart,
      })}
    >
      {useChart ? (
        <BudgetMixChartContainer
          chartData={chartData}
          isHistorical={isHistorical}
        />
      ) : (
        <BudgetMixTable tableData={chartData} />
      )}
    </div>
  );
}
